// Storage

export const STORAGE_KEY = 'copera_session';

// PAGINATION

export const PAGE_SIZE = 25;

// API

export const API_HOST = `${import.meta.env.VITE_API_HOST || ''}`;
export const GQL_HOST = `${import.meta.env.VITE_API_HOST || ''}/graphql`;
export const Y_SERVER = import.meta.env.VITE_Y_HOST || 'wss://y.copera.ai';

export const SOCKET_HOST = import.meta.env.VITE_WS_HOST || '';

// ROOT PATH AFTER LOGIN SUCCESSFUL

// RESPONSIVITY
export const SMALL_MOBILE_BREAKPOINT = 'sm';
export const MOBILE_BREAKPOINT = 'md';
export const TABLET_BREAKPOINT = 'lg';

// LAYOUT

export const HEADER = 48;

export const ALERT = 36;

export const NAV = {
  W_BASE: 260,
  W_DASHBOARD: 280,
  W_DASHBOARD_MINI: 88,
  W_DASHBOARD_COLLAPSED: 56,
  W_DASHBOARD_EXPANDED: 268,
  W_DASHBOARD_MORE_DRAWER: 308,
  //
  H_DASHBOARD_ITEM: 40,
  H_DASHBOARD_ITEM_SUB: 40,
  //
  H_DASHBOARD_NAV_LABEL: 32,
  H_DASHBOARD_ITEM_HORIZONTAL: 28,

  WORKSPACES: 240,
};

export const MAIN = {
  FULL_H: `calc(100vh - ${HEADER}px)`,
  FULL_H_WITH_ALERT: `calc(100vh - ${HEADER + ALERT}px)`,
};

export enum DrawerWidths {
  MEDIUM_WIDTH = 450,
  LARGE_WIDTH = 680,
}

export const W_DRAWER = 61;

export const BOARDS = {
  TABLE: {
    GROUP_MARGIN: 26,
    GROUP_HEADER: 48,
    HEADER: 38,
    ROW: 34,
  },
};

export const ICON = {
  NAV_ITEM: 24,
  NAV_ITEM_HORIZONTAL: 22,
  NAV_ITEM_MINI: 22,
};

export const JITSI_SERVER_CONFIG = {
  hosts: {
    domain: 'meet.jitsi',
    // muc: 'conference.meet.copera.ai',
    muc: 'muc.meet.jitsi',
  },
  serviceUrl: 'wss://meet.copera.ai/xmpp-websocket',
  // serviceUrl: 'https://meet.copera.ai/http-bind',
  focusUserJid: 'focus@auth.meet.jitsi',
  // bosh: 'https://meet.copera.ai/http-bind',
  websocket: 'wss://meet.copera.ai/xmpp-websocket',
  p2p: {
    enabled: true,
  },
};

export const LIVEKIT_SERVER_URL = import.meta.env.VITE_LIVEKIT_SERVER_URL;

export const LIVEKIT_AI_SERVER_URL = import.meta.env.VITE_LIVEKIT_AI_SERVER_URL;

export const STRIPE_PUBLISHABLE_KEY = import.meta.env
  .VITE_STRIPE_PUBLISHABLE_KEY;

export const SOUNDBOARD_CDN = 'https://cdn.copera.app/soundboard-sounds/';
